export const headerTranslations = {
  ru: {
    modes: "Режимы",
    multiverseDesc: "Политика, экономика и жизнь.",
    creativeDesc: "Бесплатные плоты и WorldEdit.",
    map: "Карта",
    stats: "Статистика",
    shop: "Магазин",
    login: "Войти",
    notifications: "Уведомления",
    wiki: "Вики"
  },
  en: {
    modes: "Modes",
    multiverseDesc: "Politics, economy, and life.",
    creativeDesc: "Free plots and WorldEdit.",
    map: "Map",
    stats: "Statistics",
    shop: "Store",
    login: "Log In",
    notifications: "Notifications",
    wiki: "Wiki"
  }
};